<div class="content-wrapper reports-container">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 19px"
  >
    <a class="widget quick-category">
      <div class="quick-category-head">
        <h5 class="card-title">{{ 'record.filter.title' | translate }}</h5>
        <div class="ml-auto">
          <button
            *ngIf="!areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.contract' | translate }}</span>
            <i class="las la-arrow-up"></i>
          </button>
          <button
            *ngIf="areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.advancedSearch' | translate }}</span>
            <i class="las la-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="quick-category-content">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.startDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="minDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [maxDate]="maxDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.endDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="maxDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [minDate]="minDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">{{ 'record.filter.user' | translate }}</h6>
              <div>
                <input
                  [(ngModel)]="user"
                  class="form-control"
                  placeholder="{{ 'record.filter.emailAddress' | translate }}"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.act' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="actions"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActions"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.department' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="departments"
                [closeOnSelect]="false"
                [(ngModel)]="selectedDeptos"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.label' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="labelsName"
                [closeOnSelect]="false"
                [(ngModel)]="selectedLabels"
                multiple="true"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                (click)="setFilters()"
                [disabled]="isLoading"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                (click)="cleanFilters()"
                [disabled]="isLoading"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="isLoading"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDropdown">
            <button class="dropdown-item" (click)="generateGeneralIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.overviewReport' | translate }}
            </button>
            <button class="dropdown-item" (click)="generateEvoIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.evolutionaryReport' | translate }}
            </button>
          </div>
        </div>
        <div>
          {{
            'record.recordsCount'
              | translate
                : { count: reports?.length || '0', total: collectionSize }
          }}
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center loader" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th
            style="width: 200px"
            scope="col"
            sortable="date"
            (sort)="onSort($event)"
          >
            {{ 'record.table.date' | translate }}
          </th>
          <th scope="col" sortable="activity" (sort)="onSort($event)">
            {{ 'record.table.act' | translate }}
          </th>
          <th scope="col" sortable="file" (sort)="onSort($event)">
            {{ 'record.table.fileSubject' | translate }}
          </th>
          <th scope="col" sortable="applicationName" (sort)="onSort($event)">
            {{ 'record.table.action' | translate }}
          </th>
          <th scope="col" sortable="actor" (sort)="onSort($event)">
            {{ 'record.table.user' | translate }}
          </th>
          <th scope="col" sortable="area" (sort)="onSort($event)">
            {{ 'record.table.department' | translate }}
          </th>
          <th scope="col" sortable="labelName" (sort)="onSort($event)">
            {{ 'record.table.label' | translate }}
          </th>
          <!-- 
            <th scope="col">

            </th>
            -->
        </tr>
      </thead>
      <tbody *ngIf="!isLoading">
        <tr *ngFor="let report of reports">
          <td>{{ formatDateTable(report.date) }}</td>
          <td
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ report.activity }}"
          >
            {{ cutString(report.activity) }}
          </td>
          <td
            style="cursor: pointer"
            (click)="seeDetails(report.id)"
            data-toggle="tooltip"
            placement="top"
            animation="true"
            container="body"
            [openDelay]="300"
            [closeDelay]="300"
            ngbTooltip="{{ report.file }}"
          >
            {{ cutString(report.file) }}
          </td>
          <td>{{ report.applicationName }}</td>
          <td>{{ report.actor }}</td>
          <td>{{ report.area }}</td>
          <td>{{ report.labelName }}</td>
          <!--
            <td>
              <button style="border: none; padding: 0; background: transparent;"><i class="las la-eye font-25"></i></button>
            </td>
          -->
        </tr>
      </tbody>
    </table>

    <div
      *ngIf="reports?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>
</div>
